// Função de debug para exportação
export const debugExportData = (data, context = 'unknown') => {
  console.group(`🔍 Debug Export - ${context}`);
  
  console.log('📊 Tipo dos dados:', Array.isArray(data) ? 'Array' : typeof data);
  console.log('📏 Quantidade de itens:', Array.isArray(data) ? data.length : 'N/A');
  
  if (Array.isArray(data) && data.length > 0) {
    console.log('🎯 Primeiro item:', data[0]);
    console.log('🔑 Chaves do primeiro item:', Object.keys(data[0] || {}));
    console.log('📝 Tipos dos valores:');
    
    const firstItem = data[0] || {};
    Object.keys(firstItem).forEach(key => {
      const value = firstItem[key];
      const type = typeof value;
      const isArray = Array.isArray(value);
      const isNull = value === null;
      
      console.log(`   ${key}: ${isNull ? 'null' : isArray ? 'Array' : type}`, 
                  isArray ? `(${value.length} items)` : 
                  type === 'object' && !isNull ? '(objeto complexo)' : 
                  `(${value})`);
    });
    
    // Verificar se há objetos aninhados problemáticos
    const problematicKeys = Object.keys(firstItem).filter(key => {
      const value = firstItem[key];
      return typeof value === 'object' && value !== null && !Array.isArray(value);
    });
    
    if (problematicKeys.length > 0) {
      console.warn('⚠️ Chaves com objetos aninhados que podem causar [object Object]:', problematicKeys);
      problematicKeys.forEach(key => {
        console.log(`   ${key}:`, firstItem[key]);
      });
    }
  } else {
    console.log('📦 Dados completos:', data);
  }
  
  console.groupEnd();
  return data;
};

// Função para "achatar" dados complexos
export const flattenExportData = (data) => {
  if (!Array.isArray(data)) {
    return data;
  }
  
  return data.map(item => {
    if (typeof item !== 'object' || item === null) {
      return { valor: String(item) };
    }
    
    const flattened = {};
    Object.keys(item).forEach(key => {
      const value = item[key];
      
      if (value === null || value === undefined) {
        flattened[key] = '';
      } else if (typeof value === 'object') {
        if (Array.isArray(value)) {
          flattened[key] = value.join(', ');
        } else {
          // Objeto complexo - tentar extrair valor útil
          if (value.name) flattened[key] = value.name;
          else if (value.title) flattened[key] = value.title;
          else if (value.label) flattened[key] = value.label;
          else if (value.value) flattened[key] = value.value;
          else if (Object.keys(value).length === 1) {
            flattened[key] = Object.values(value)[0];
          } else {
            flattened[key] = `[${Object.keys(value).join(', ')}]`;
          }
        }
      } else {
        flattened[key] = String(value);
      }
    });
    
    return flattened;
  });
};

export default {
  debugExportData,
  flattenExportData
}; 